export enum MessageType {
	TEXT = 'text',
	MEDIA = 'media',
	VOICE = 'voice',
	EVENT = 'event',
	COMMAND = 'command',
	ERROR = 'error'
}
